export default "__VITE_ASSET__oD8WyeO8__"